import { render, staticRenderFns } from "./PracticeShipRepairDetailsContent.vue?vue&type=template&id=7ed2b50f"
import script from "./PracticeShipRepairDetailsContent.vue?vue&type=script&lang=ts"
export * from "./PracticeShipRepairDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports